// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1bb0eb43","463":"d1dd81a5","546":"6cda234b"}[chunkId] + ".chunk.js";
};